import { AlertTriangle, ServerCrash, WifiOff, X } from "lucide-react"

// Fallas del sistema: no son culpa del usuario, por eso usan la paleta café y no el rojo
const SYSTEM_ERRORS = {
  server: { icon: ServerCrash, title: "Servicio no disponible" },
  connection: { icon: WifiOff, title: "Sin conexión" },
}

const CloseButton = ({ onClose }) =>
  onClose ? (
    <button
      type="button"
      onClick={onClose}
      className="ml-2 flex-shrink-0 rounded-md p-0.5 text-neutral-200 hover:text-neutral-400 transition-colors duration-200"
      aria-label="Cerrar"
    >
      <X className="h-4 w-4" />
    </button>
  ) : null

// Alerta de error de formularios. kind: "user" (por defecto), "server" o "connection" (ver utils/http)
const ErrorAlert = ({ message, kind = "user", onClose }) => {
  const system = SYSTEM_ERRORS[kind]

  if (system) {
    const Icon = system.icon
    return (
      <div role="alert" className="flex items-start gap-3 rounded-xl border border-cafe-200/50 bg-[#FBF8F5] px-4 py-3.5 text-left animate-fade-in">
        <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-cafe-100/60 text-cafe-600">
          <Icon className="h-[18px] w-[18px]" />
        </span>
        <div className="min-w-0 flex-1 pt-0.5">
          <p className="text-sm font-semibold text-cafe-800">{system.title}</p>
          <p className="mt-0.5 text-[13px] leading-relaxed text-cafe-500">{message}</p>
        </div>
        <CloseButton onClose={onClose} />
      </div>
    )
  }

  return (
    <div key={message} role="alert" className="flex items-start justify-between rounded-md bg-red-50 px-4 py-3 text-left animate-shake">
      <div className="flex items-start">
        <AlertTriangle className="mt-0.5 h-4 w-4 flex-shrink-0 text-red-600" />
        <p className="ml-2.5 text-sm text-red-700">{message}</p>
      </div>
      <CloseButton onClose={onClose} />
    </div>
  )
}

export default ErrorAlert
